<template>
  <div>
    <div class="restaurant-info">
      <img :src="restaurantInfo.logo" style="height:80px;width:80px;float:left;" />
      <h1>{{ restaurantInfo.name }}</h1>
      <el-carousel :interval="4000" type="card" height="600px">
        <el-carousel-item v-for="pic,index in restaurantInfo.pics" :key="index">
          <img :src="pic" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="food-info">
      <div class="total-price">
        <span>{{ $t('label.total') }}:S/. {{ parseFloat(selectedSpec.reduce((ac, ci) => ac + ci.unitPrice * ci.count + ci.adjustPrice * ci.count + ci.selfAdjustPrice * ci.count, 0).toFixed(2)) }}</span>
      </div>
      <div v-for="spec,index in selectedSpec" :key="index" class="customer-food-block">
        <img :src="spec.pic" />
        <p class="name">{{ spec.name }}</p>
        <p class="des">{{ spec.des }}</p>
        <p class="count">x {{ spec.count }}</p>
        <p class="price">S/. {{ parseFloat((spec.unitPrice * spec.count + spec.adjustPrice * spec.count + spec.selfAdjustPrice * spec.count).toFixed(2)) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getRestaurantInfo } from '@/api/getInfo'

export default {
  data() {
    return {
      restaurantInfo: {
        name: '',
        des: '',
        logo: '',
        pics: []
      },
      selectedSpec: []
    }
  },
  mounted() {
    const channel = new BroadcastChannel('customerChannel')
    channel.onmessage = (event) => {
      this.selectedSpec = event.data
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      const {
        restaurantId,
      } = this.$route.query
      getRestaurantInfo({ restaurantId }).then(res => {
        this.restaurantInfo.name = res.name
        this.restaurantInfo.des = res.description
        this.restaurantInfo.logo = res.logo
        this.restaurantInfo.pics = res.pics
      })
    },
  }
}
</script>

<style>
.restaurant-info {
  float: left;
  width: 49%;
}
.food-info {
  float: right;
  width: 50%;
}
.customer-food-block {
  height: 140px;
  border: 2px solid #409EFF;
  margin-bottom: 2px;
}
.customer-food-block img {
  float: left;
  height: 140px;
  width: 140px;
}
.customer-food-block p {
  margin-top: 5px;
  margin-bottom: 5px;
  text-align: right;
  padding-right: 10px;
  font-weight: bold;
}
.customer-food-block .name {
  font-size: 19px;
  color: #303133;
}
.customer-food-block .des {
  font-size: 16px;
  color: #909399;
}
.customer-food-block .count {
  font-size: 16px;
  color: #303133;
}
.customer-food-block .price {
  font-size: 20px;
  color: #F56C6C;
}
.total-price {
  background-color: #E6A23C;
  height: 40px;
  font-size: 20px;
  text-align: right;
  font-weight: bold;
  padding-top: 10px;
  padding-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/Customer.vue